export default [
  {
    path: '/cache-management',
    name: 'cache-management',
    component: () => import('../../views/cache-management/cache.vue'),
    meta: {
      pageTitle: 'Cache Management',
      breadcrumbs: ['Cache Management'],
    },
    children: [
      {
        path: '',
        name: 'cache-management-list',
        component: () => import('../../views/cache-management/list.vue')
      },
      // {
      //   path: 'create',
      //   name: 'podcasts-create',
      //   component: () => import('../../views/podcasts/create.vue'),
      //   meta: {
      //     pageTitle: 'Create Podcast',
      //     breadcrumbs: ['Podcasts', 'Create'],
      //   }
      // },
      // {
      //   path: 'download-audio',
      //   name: 'podcasts-download-audio',
      //   component: () => import('../../views/podcasts/download-audio.vue'),
      //   meta: {
      //     pageTitle: 'Download Audio',
      //     breadcrumbs: ['Podcasts', 'Download Audio'],
      //   }
      // },
      // {
      //   path: ':id/edit',
      //   name: 'podcasts-edit',
      //   component: () => import('../../views/podcasts/edit.vue'),
      //   meta: {
      //     pageTitle: 'Edit Podcast',
      //     breadcrumbs: ['Podcasts', 'Edit'],
      //   }
      // }
    ]
  }
]
